import React, { useEffect, useState } from 'react';
import {
    Button, InputGroup, InputGroupText,
    Card,Badge,Spinner, Table,
    CardHeader,Collapse, Modal,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Form,
    Input,
    Row,Label,
    Col,
    Container,
    ModalHeader,
    ModalBody,
    ModalFooter,
  } from "reactstrap";




function CreateVInfon(props) {
   
    const [showProcessing, setShowProcessing] = useState(false)
    const [vdata , setVdata ] = useState({
        vid : "",
        luid : "",
        tluid: "",
        tuid : "",
        listingtype : "",
        categoryCode : "", 
        category : {en : "", fr : "", ar : ""},
        bid : "",
        blogo : "",
        bname :   {en : "", fr : "", ar : ""},
        mname :  {en : "", fr : "", ar : ""},
        modelyear : {value : "", label :""},
        notes : "",
        vtypeCode : "",
        vtname : {en : "", fr : "", ar : ""},
        features: [{featureCode : "", en : "", fr : "", ar : "", unit : "", rangeid : "" , rangevalueL : "" , rangevalueH: ""}],
        insurence : true,
        intcolor  : "",
        extcolor : "",
        approxmiles : "",
        daily : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        fdaily : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        weekly : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        fweekly : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        monthly : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        fmonthly : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        fuelCode : "",
        fuelname  : {en :"", fr : "", ar: ""},
        trmCode : "",
        trmname : {en : "", fr : "", ar : ""}
      })


    useEffect(() => {
        
        fetchvehicle(props.vehicle.tluid)
      }, [props.vehicle])

      const fetchvehicle = (tluid) => {
        
        setShowProcessing(true)
        tluid && props.API.get(`tenant/getlistingn/${tluid}`, { headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                
           setVdata(res.data.data)
            setShowProcessing(false)
          }).catch(function (error) {
            setShowProcessing(false)
          }) 
      }

      const showVehicle = () => {
        return (
              <Table style={{fontSize : "0.8rem"}}>
                <thead>
                    <tr>
                  <th></th>
                  <th>Feature</th>
                  <th style={{textAlign : "center"}}>Value</th>
                  {/** <th style={{textAlign : "center"}}>Max</th> */}
                  </tr>
                </thead>
                <tbody>
                  {
                     vdata.features.map((x , key) => {
                      if(x.featureCode !== ""){
                        return (
                          <tr key={key}>
                            <td><img alt="..." width={"30px"} src={`${x.ficon}`} style={{ cursor : "pointer"}} /> </td>
                            <td>{x.en}</td>
                            <td style={{textAlign : "center"}}>{x.rangevalueL}</td>
                         {/**   <td style={{textAlign : "center"}}>{x.rangevalueH}</td>*/} 
                        
                          </tr>
                        )  
                      }
                      })
                  }
                 
                </tbody>
              </Table>
         
        )
      }

      const enqClick = (cidn) => {
       
           
             let bdy = {cid  : cidn, deviceid : "Browser", uid : "Admin" , tuid  : vdata.tuid, tluid : vdata.tluid , vtypecode : vdata.vtypeCode , catcode : vdata.categoryCode }
              props.API.post(`cdet`, bdy, { headers :{"arixauth" : localStorage.getItem("arixauth")}}).then(rs => {
                
              })
       
        
      }
      

    try{
        return (
            
            <Modal isOpen={props.infom}  style={{marginTop : -40, minWidth : "80%"}}>
                 
                        <Row style={{paddingLeft : 10, paddingRight : 10, paddingTop : 10}}><Col>Listing ID : {vdata.luid}</Col><Col ><span style={{float : "right"}}><i><b>{vdata.listingType}</b></i></span></Col></Row>
                
                    <ModalBody>
                    <hr />
                        <Row>
                              <Col>
                              <Row style={{marginTop : 10}}>
                            <Col md="6">
                                    <center><img alt="..." width={"140px"} src={`${vdata.imgmc}`} style={{ cursor : "pointer"}} /> </center>
                            </Col>
                            <Col md="6">
                                <Row>   
                                     <Col md="6"><center><img alt="..." width={"80px"} src={`${vdata.imgpc[0]}`} style={{ cursor : "pointer"}} /> </center></Col>   
                                     <Col md="6"><center><img alt="..." width={"80px"} src={`${vdata.imgpc[1]}`} style={{ cursor : "pointer"}} /> </center></Col>    
                                </Row>
                                <Row style={{marginTop  : 10}}>
                                    <Col md="6"><center><img alt="..." width={"80px"} src={`${vdata.imgpc[2]}`} style={{ cursor : "pointer"}} /> </center></Col>    
                                    <Col md="6"><center><img alt="..." width={"80px"} src={`${vdata.imgpc[3]}`} style={{ cursor : "pointer"}} /> </center></Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row style={{textAlign : "center", marginTop : 10}}>
                            <Col md="3">Brand  <h6>{vdata.bname.en} - {vdata.bname.ar}</h6> </Col>
                            <Col md="3">Model  <h6>{vdata.mname.en} - {vdata.mname.ar}</h6> </Col>
                            <Col md="3">Year  <h6>{vdata.modelyear.label}</h6></Col>
                            <Col md="3">Type  <h6>{vdata.vtname.en} - {vdata.vtname.ar}</h6></Col>
                        </Row>
                        <hr />
                        <Row style={{textAlign : "center"}}>
                            <Col md="3">Interior  <h6>{vdata.intcolor}</h6></Col>
                            <Col md="3">Exterior <h6>{vdata.extcolor}</h6></Col>
                            <Col md="3">Insurence <h6> {vdata.insurence ? "Full" : "Third Party"}</h6></Col>
                            <Col md="3">Running <h6>{vdata.approxmiles}</h6></Col>
                        </Row>
                        <hr />
                        <Row>
                            <Col md="6">Fuel : {vdata.fuelname.en}</Col>
                            <Col md="6"><span style={{float : "right"}}>Transmission : {vdata.trmname.en}</span></Col>
                        </Row>
                            <Table>
                                <thead style={{textAlign : "center"}}>
                                    <tr >
                                        <th></th>
                                        <th>Amount</th>
                                        <th>Miles</th>
                                        <th>With Driver</th>
                                        <th>X Miles</th>
                                    </tr>
                                </thead>
                                <tbody style={{textAlign : "center"}}>
                                    <tr>
                                        <td>Daily</td>
                                        <td>{vdata.daily.amt}</td>
                                        <td>{vdata.daily.mileq}</td>
                                        <td>{vdata.daily.wdamt}</td>
                                        <td>{vdata.daily.xmileq}</td>
                                    </tr>
                                    <tr>
                                        <td>Daily <span style={{color : "red"}}>*</span></td>
                                        <td>{vdata.fdaily.amt}</td>
                                        <td>{vdata.fdaily.mileq}</td>
                                        <td>{vdata.fdaily.wdamt}</td>
                                        <td>{vdata.fdaily.xmileq}</td>
                                    </tr>
                                    <tr>
                                        <td>Weekly</td>
                                        <td>{vdata.weekly.amt}</td>
                                        <td>{vdata.weekly.mileq}</td>
                                        <td>{vdata.weekly.wdamt}</td>
                                        <td>{vdata.weekly.xmileq}</td>
                                    </tr>
                                    <tr>
                                        <td>Weekly <span style={{color : "red"}}>*</span></td>
                                        <td>{vdata.fweekly.amt}</td>
                                        <td>{vdata.fweekly.mileq}</td>
                                        <td>{vdata.fweekly.wdamt}</td>
                                        <td>{vdata.fweekly.xmileq}</td>
                                    </tr>
                                    <tr>
                                        <td>Monthly </td>
                                        <td>{vdata.monthly.amt}</td>
                                        <td>{vdata.monthly.mileq}</td>
                                        <td>{vdata.monthly.wdamt}</td>
                                        <td>{vdata.monthly.xmileq}</td>
                                    </tr>
                                    <tr>
                                        <td>Monthly <span style={{color : "red"}}>*</span></td>
                                        <td>{vdata.fmonthly.amt}</td>
                                        <td>{vdata.fmonthly.mileq}</td>
                                        <td>{vdata.fmonthly.wdamt}</td>
                                        <td>{vdata.fmonthly.xmileq}</td>
                                    </tr>
                                </tbody>
                            </Table>
                              </Col>
                              <Col style={{borderLeft : "1px solid lightgray"}}>
                                <b>Features</b>
                                {showVehicle(vdata.features)}
                              </Col>
                              <Col style={{borderLeft : "1px solid lightgray"}}>
                                <Row>
                                    <Col>
                                    <label>Additional info</label> : 
                                    <p>{vdata.additionalinfo.en}</p>
                                    <p>{vdata.additionalinfo.fr}</p>
                                    <p>{vdata.additionalinfo.ar}</p>
                                    </Col>
                                </Row>
                                <hr />
                                <Row style={{marginTop : 15}}> 
                                    <Col>
                                    <label>Documents required for UAE Resident</label> : 
                                    <p>{vdata.documentsrequiredresident.en}</p>
                                    <p>{vdata.documentsrequiredresident.fr}</p>
                                    <p>{vdata.documentsrequiredresident.ar}</p>
                                    </Col>
                                </Row>
                                <hr />
                                <Row style={{marginTop : 15}}> 
                                    <Col>
                                    <label>Documents required for Tourist</label> : 
                                    <p>{vdata.documentsrequiredtourist.en}</p>
                                    <p>{vdata.documentsrequiredtourist.fr}</p>
                                    <p>{vdata.documentsrequiredtourist.ar}</p>
                                    </Col>
                                </Row>
                                <hr />
                                <Row>
                                    <Col><span>Salik / Toll Charges : {vdata.saliktollcharges}</span></Col>
                                    <Col ><span style={{float : "right"}}>Security Deposit : {vdata.securitydeposit}</span></Col>
                                </Row>
                                <hr />
                                <Row>
                                    <Col><span>Refund Days: {vdata.refunddays}</span></Col>
                                    <Col><span  style={{float : "right"}}>Min Driver Age : {vdata.mindriverage}</span></Col>
                                </Row>
                              </Col>
                        </Row>
                        <Row>
                            <Col>
                            <Button size="sm" onClick={p => {props.setInfom(false);
                                                      enqClick("1")  }} style={{float : "left"}}>Whatsapp </Button>          
                            </Col>
                            <Col>
                                        <Button size="sm" onClick={p => props.setInfom(false)} style={{float : "right"}}>Close</Button>          
                                        <Button size="sm" onClick={p => {props.setInfom(false);
                                                      enqClick("3")  }} style={{float : "right", marginRight : 10}}>Enq & Close</Button>          
                            </Col>
                        </Row>     
                    </ModalBody>
                  
                  
            </Modal>
        );
    }catch(e){
        
        return(
            <Modal isOpen={props.infom}  style={{marginTop : -40, minWidth : "80%"}}>
            <div>Error</div>
            </Modal>
        )
    }
    
}

export default CreateVInfon;